var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "#CE2139",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.932 4.375H2.068c-.163 0-.295.13-.295.292v8.166c0 .645.529 1.167 1.182 1.167h7.09c.653 0 1.182-.522 1.182-1.167V4.667c0-.161-.132-.292-.295-.292zm-5.466 7.583c0 .242-.199.438-.443.438-.245 0-.443-.196-.443-.438v-5.25c0-.241.198-.437.443-.437.244 0 .443.196.443.437v5.25zm2.954 0c0 .242-.198.438-.443.438-.244 0-.443-.196-.443-.438v-5.25c0-.241.199-.437.443-.437.245 0 .443.196.443.437v5.25zM12.41 2.333H9.601c-.081 0-.147-.065-.147-.146v-.729C9.455.653 8.793 0 7.977 0H5.023c-.816 0-1.478.653-1.478 1.458v.73c0 .038-.015.075-.043.103-.028.027-.065.042-.104.042H.59c-.326 0-.591.262-.591.584 0 .322.265.583.59.583h11.82c.325 0 .59-.261.59-.583 0-.322-.265-.584-.59-.584zm-7.683-.146v-.729c0-.16.133-.291.296-.291h2.954c.163 0 .296.13.296.291v.73c0 .08-.066.145-.148.145h-3.25c-.082 0-.148-.065-.148-.146z",
    transform: "translate(-1157 -564) translate(1128 564) translate(29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.0d6c15943f1425b9066b119d65ce1924.svg";
export { ForwardRef as ReactComponent };